import axios from "axios";

const API = `${
  process.env.REACT_APP_API_URL || "http://localhost:5001"
}/api/kitty-report`;

export const analyzeKittyReportApi = ({ file, ratePercent }) => {
  const fd = new FormData();
  fd.append("file", file);
  if (ratePercent != null) fd.append("ratePercent", String(ratePercent));
  return axios.post(`${API}/analyze`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// Streams a formatted .xlsx and hands it to the browser as a download.
export const downloadKittyReportExcel = async ({ file, ratePercent }) => {
  const fd = new FormData();
  fd.append("file", file);
  if (ratePercent != null) fd.append("ratePercent", String(ratePercent));
  const res = await axios.post(`${API}/export`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
    responseType: "blob",
  });
  const match = (res.headers["content-disposition"] || "").match(
    /filename="?([^"]+)"?/,
  );
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = match ? match[1] : "kitty-report.xlsx";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

// ── Day-by-day manual entry ledger ──────────────────────────────────────
export const addKittyEntryApi = ({ date, amount, account }) =>
  axios.post(`${API}/entries`, { date, amount, account });

export const listKittyEntriesApi = ({ month = "", account = "" } = {}) =>
  axios.get(`${API}/entries`, { params: { month, account } });

export const deleteKittyEntryApi = (id) => axios.delete(`${API}/entries/${id}`);
